var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendPopup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2032_7799)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.1762 4.26738C15.5002 3.37113 14.6317 2.50263 13.7354 2.82738L2.78166 6.78888C1.88241 7.11438 1.77366 8.34138 2.60091 8.82063L6.09741 10.8449L9.21966 7.72263C9.36111 7.58601 9.55056 7.51041 9.74721 7.51212C9.94386 7.51383 10.132 7.59271 10.271 7.73176C10.4101 7.87082 10.489 8.05893 10.4907 8.25557C10.4924 8.45222 10.4168 8.64167 10.2802 8.78313L7.15791 11.9054L9.18291 15.4019C9.66141 16.2291 10.8884 16.1196 11.2139 15.2211L15.1762 4.26738Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2032_7799"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendPopup);
export default __webpack_public_path__ + "static/media/send-popup.b0d731fdfd11a03e81f90ec6eae33794.svg";
export { ForwardRef as ReactComponent };